import { HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { ApiPath, ApiService, YearMonth } from '@financial/arch';
import { IncomesAndExpenses } from "@financial/domain";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class IncomesAndExpensesService {
  private apiPath: ApiPath;

  constructor(api: ApiService) {
    this.apiPath = api.root.path('reports').path('incomesAndExpensesByPeriod');
  }

  findBy(yearMonth: YearMonth): Observable<IncomesAndExpenses> {
    const params = new HttpParams().append('monthReference', yearMonth.toDefaultString());

    return this.apiPath
      .getJson<IncomesAndExpenses>({ params: params })
      .pipe(retry(3));
  }
}
